// Decorative sparkle that flies across the page with a fading tail.
// Tapping near one nudges it gently sideways. Skipped entirely when the
// visitor prefers reduced motion.
(() => {
  const canvas = document.getElementById('sky');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const TAP_RADIUS = 60;     // px from the sparkle's centre that counts as a tap on it
  const NUDGE = 0.9;         // px per frame of sideways push, applied once per tap
  const NUDGE_DECAY = 0.96;  // the push fades back to the original path over ~1 second
  const SPARK_LIFE = 30;     // frames a burst spark lives
  const { ink: INK, glow: GLOW } = window.squishystartzSprites;

  // 9x9 pixel sparkle, matching the 8-bit sprites in the parade and hero
  const PIXEL_ART = [
    '....#....',
    '....#....',
    '...###...',
    '..#####..',
    '#########',
    '..#####..',
    '...###...',
    '....#....',
    '....#....',
  ];

  // Draw the sparkle once onto a small canvas, then scale it up with smoothing off
  // so every pixel stays a hard square.
  const sprite = document.createElement('canvas');
  sprite.width = 9;
  sprite.height = 9;
  const spriteCtx = sprite.getContext('2d');
  PIXEL_ART.forEach((row, y) => {
    [...row].forEach((cell, x) => {
      if (cell !== '#') return;
      spriteCtx.fillStyle = x === 4 && y === 4 ? GLOW : INK;
      spriteCtx.fillRect(x, y, 1, 1);
    });
  });

  let sparkles = [];
  let sparks = [];
  let nextAt = 0;

  function fit() {
    canvas.width = window.innerWidth * devicePixelRatio;
    canvas.height = window.innerHeight * devicePixelRatio;
    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
    ctx.imageSmoothingEnabled = false;
  }

  // Enter from a random edge and cross to the opposite side, so the
  // sparkle doesn't always come from the same direction.
  function spawn() {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const pad = 80;
    const edge = Math.floor(Math.random() * 4);
    let x, y, targetX, targetY;

    if (edge === 0) {
      x = Math.random() * w; y = -pad;
      targetX = Math.random() * w; targetY = h + pad;
    } else if (edge === 1) {
      x = w + pad; y = Math.random() * h;
      targetX = -pad; targetY = Math.random() * h;
    } else if (edge === 2) {
      x = Math.random() * w; y = h + pad;
      targetX = Math.random() * w; targetY = -pad;
    } else {
      x = -pad; y = Math.random() * h;
      targetX = w + pad; targetY = Math.random() * h;
    }

    const angle = Math.atan2(targetY - y, targetX - x);
    const speed = 2.5 + Math.random() * 1.5;
    const pixel = 3 + Math.floor(Math.random() * 3); // 3-5px per pixel of art
    sparkles.push({
      x, y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      nudgeX: 0,
      nudgeY: 0,
      size: pixel * 9,
      trail: [],
    });
  }

  // Push sideways, away from the side the tap landed on.
  function nudge(s, tapX, tapY) {
    const len = Math.hypot(s.vx, s.vy) || 1;
    const dirX = s.vx / len;
    const dirY = s.vy / len;
    const tapSide = (tapX - s.x) * -dirY + (tapY - s.y) * dirX;
    const sign = tapSide > 0 ? -1 : 1;
    s.nudgeX += -dirY * NUDGE * sign;
    s.nudgeY += dirX * NUDGE * sign;
  }

  function burst(x, y) {
    for (let i = 0; i < 6; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.8 + Math.random() * 0.8;
      sparks.push({
        x, y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        life: SPARK_LIFE,
      });
    }
  }

  function onTap(event) {
    for (const s of sparkles) {
      if (Math.hypot(event.clientX - s.x, event.clientY - s.y) < TAP_RADIUS) {
        nudge(s, event.clientX, event.clientY);
        burst(s.x, s.y);
      }
    }
  }

  function frame(now) {
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

    if (now > nextAt) {
      spawn();
      nextAt = now + 20000 + Math.random() * 15000;
    }

    sparkles = sparkles.filter((s) =>
      s.x > -200 && s.x < window.innerWidth + 200 &&
      s.y > -200 && s.y < window.innerHeight + 200
    );

    for (const s of sparkles) {
      s.x += s.vx + s.nudgeX;
      s.y += s.vy + s.nudgeY;
      s.nudgeX *= NUDGE_DECAY;
      s.nudgeY *= NUDGE_DECAY;

      s.trail.push({ x: s.x, y: s.y });
      if (s.trail.length > 180) s.trail.shift();

      // Pixel tail: square blocks snapped to a 2px grid, growing chunkier toward the head
      for (let i = 0; i < s.trail.length; i++) {
        const a = i / s.trail.length;
        const p = s.trail[i];
        const block = 2 + Math.floor(a * 3) * 2; // 2, 4 or 6px
        const gx = Math.round(p.x / 2) * 2;
        const gy = Math.round(p.y / 2) * 2;
        ctx.fillStyle = `rgba(233, 162, 59, ${a * 0.8})`;
        ctx.fillRect(gx - block / 2, gy - block / 2, block, block);
      }

      ctx.drawImage(sprite, Math.round(s.x - s.size / 2), Math.round(s.y - s.size / 2), s.size, s.size);
    }

    sparks = sparks.filter((k) => k.life > 0);
    for (const k of sparks) {
      k.x += k.vx;
      k.y += k.vy;
      k.life -= 1;
      ctx.fillStyle = `rgba(233, 162, 59, ${k.life / SPARK_LIFE})`;
      ctx.fillRect(Math.round(k.x), Math.round(k.y), 2, 2);
    }

    rafId = requestAnimationFrame(frame);
  }

  let rafId = null;
  let resizeTimer = null;

  function debouncedFit() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fit, 150);
  }

  function start() {
    if (rafId === null) rafId = requestAnimationFrame(frame);
  }

  function stop() {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  fit();
  window.addEventListener('resize', debouncedFit);

  if (!reduceMotion) {
    window.addEventListener('pointerdown', onTap, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });
    start();
  }
})();
